import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

/**
 * Initialize Google Analytics 4
 * Only initializes if VITE_GA_MEASUREMENT_ID is set
 */
export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

/**
 * Track a page view
 * @param path - The page path (e.g., "/projects" or "/survey/123")
 */
export const trackPageView = (path: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

/**
 * Track a custom event
 * @param category - Event category (e.g., "Survey", "User")
 * @param action - Event action (e.g., "Created", "Submitted")
 * @param label - Optional label for additional context
 * @param value - Optional numeric value
 */
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

/**
 * Track when a user completes a survey
 */
export const trackSurveyCompletion = (surveyId: string) => {
  trackEvent("Survey", "Completed", surveyId);
};

/**
 * Track when a user creates a new survey
 */
export const trackSurveyCreated = (surveyId: string) => {
  trackEvent("Survey", "Created", surveyId);
};

/**
 * Track when a user uploads a document
 */
export const trackDocumentUpload = (fileType: string) => {
  trackEvent("Document", "Uploaded", fileType);
};

/**
 * Track user authentication events
 */
export const trackAuth = (action: "Login" | "Logout" | "Signup", method?: string) => {
  trackEvent("Auth", action, method);
};
